import type {AssigneePickerAssignee} from '@github-ui/item-picker-assignee-relay'
import {ActionList} from '@primer/react'
import {AssigneeVisual} from './AssigneeVisual'
import {isCopilot} from './copilot-user'
import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {VALUES} from './constants/values'

import styles from './Assignees.module.css'

export type AssigneesProps = {
  assignees: AssigneePickerAssignee[]
  testId?: string
}

export function Assignees({assignees, testId}: AssigneesProps) {
  return (
    <ActionList variant={'full'} className={styles.assigneesList}>
      {assignees.sort(sortByLogin).map(assignee => {
        const {login, avatarUrl, profileResourcePath} = assignee
        const displayName = isCopilot(login) ? VALUES.copilot.displayName : login
        return (
          <ActionList.LinkItem
            key={assignee.id}
            href={profileResourcePath ?? undefined}
            target="_blank"
            {...hovercardAttributesForActor(login, {isCopilot: isCopilot(login)})}
          >
            <ActionList.LeadingVisual>
              <AssigneeVisual login={login} id={assignee.id} avatarUrl={avatarUrl} />
            </ActionList.LeadingVisual>
            <div data-testid={testId} className={styles.assigneeNameLabel}>
              {displayName}
            </div>
          </ActionList.LinkItem>
        )
      })}
    </ActionList>
  )
}

function sortByLogin(a: AssigneePickerAssignee, b: AssigneePickerAssignee) {
  return a.login === b.login ? 0 : a.login > b.login ? 1 : -1
}

try{ Assignees.displayName ||= 'Assignees' } catch {}